export class DataStation{
    stationID:string
    pollutantID:string
}